import { Event } from '../../store/events/eventTypes';
import { UserMemberships } from '../../store/SubscriptionsManagement/subscriptionsManagementTypes';

export interface MembershipDates {
  fromDate: number;
  toDate: number;
}

export const setEventPriceFromMembership = (
  events: Event[],
  membershipsMap: Map<number, MembershipDates[]>
) => {
  const updatedEvents = events.map((event) => {
    const membership = membershipsMap.get(event.subCategoryId);
    if (membership) {
      let newEvent: Event;
      membership.forEach((item) => {
        if (+item.fromDate < event.fromDate && +item.toDate > event.fromDate) {
          newEvent = {
            ...event,
            price: 0,
          };
        } else {
          newEvent = event;
        }
      });
      // @ts-ignore
      return newEvent;
    }

    return event;
  });

  return updatedEvents;
};
